import React from 'react';
import 'isomorphic-unfetch';
import { isType } from '@nubank/nuds-web/utils/isType/isType';

import isEmpty from '../utils/object/isEmpty';
import {
  getAccessToken as getAccessTokenFn,
  getGoogleDocument as getGoogleDocumentFn,
} from '../utils/googleDocs/request';
import {
  extractDocumentContent as extractDocumentContentFn,
} from '../utils/googleDocs/parse';

export const fetchDocument = (
  getAccessToken = getAccessTokenFn,
  getGoogleDocument = getGoogleDocumentFn,
  extractDocumentContent = extractDocumentContentFn,
) => documentId => async ({ req, query }) => {
  const isObject = isType('object', documentId);
  const { locale } = query;

  if (isObject && isEmpty(documentId[locale])) {
    throw new Error(`The provided document object does not contain an entry for the ${locale} locale`);
  }

  if (!req || !documentId) {
    return {};
  }

  const googleDocsID = isObject ? documentId[locale] : documentId;

  try {
    const token = await getAccessToken();
    const document = await getGoogleDocument(googleDocsID, token);
    const pageContent = extractDocumentContent(document);

    return { pageContent };
  } catch (e) {
    throw new Error(`Error when trying to download the document with id: ${googleDocsID}`);
  }
};

function contractPage(Component, { googleDocumentId } = {}) {
  function ContractPage(props) {
    return <Component {...props} />;
  }

  ContractPage.getInitialProps = fetchDocument()(googleDocumentId);

  return ContractPage;
}

export default contractPage;
